import type {
  TUserDto,
  TUserResponse,
  TUserUpdateDto,
  UpdateUserPasswordInterface,
  UserUpdatePayloadInterface
} from '@/types/user.type';

import { ApiConnector } from '../api.connector';

class UserApi extends ApiConnector {
  public getAdminAllUsers(
    limit?: number,
    offset?: number,
    searchTerm?: string,
    isActive?: boolean,
    position?: string
  ): Promise<{
    total: number;
    data: TUserDto[];
  }> {
    return this.call({
      path: 'admin/users',
      params: {
        limit,
        offset,
        searchTerm,
        ...(isActive !== undefined ? { isActive } : {}),
        position
      },
      cancelable: true
    });
  }

  public createAdminUser(data: UserUpdatePayloadInterface) {
    return this.call({
      path: 'admin/users',
      method: 'post',
      body: data
    });
  }

  public updateAdminUser(
    userId: string,
    data: TUserUpdateDto | Omit<UpdateUserPasswordInterface, 'uuid'>
  ) {
    return this.call({
      path: `admin/users/${userId}`,
      method: 'patch',
      body: data
    });
  }

  public getAdminUserById(uuid: string): Promise<TUserResponse> {
    return this.call({
      path: `admin/users/${uuid}`,
      cancelable: true
    });
  }

  public getUsersByDealer(
    dealerId: string
  ): Promise<
    Pick<
      TUserResponse,
      'email' | 'first_name' | 'last_name' | 'login' | 'middle_name' | 'uuid'
    >[]
  > {
    return this.call({
      path: `users/${dealerId}/findByDelaer`
    });
  }
}

export const userApi = new UserApi();
